import { render, staticRenderFns } from "./List.vue?vue&type=template&id=24f5acfd&scoped=true&"
import script from "./List.vue?vue&type=script&lang=babel&"
export * from "./List.vue?vue&type=script&lang=babel&"
import style0 from "./List.vue?vue&type=style&index=0&id=24f5acfd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f5acfd",
  null
  
)

export default component.exports